<template>
  <div class>
    <div class="row">
      <form class="offset-3 col-sm-6" @submit="fnCadastra">
        <div class="card" style="padding:15px;">
          <h4>Alterar cadastro</h4>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="_formCadastro">CNPJ</label>
              <input
                type="text"
                class="form-control"
                v-model="cadastro.cnpj"
                id="_formCadastro"
                placeholder="CNPJ"
                required
                maxlength="14"
                v-mask="'##############'"
                @change="validaCnpj"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="_login">Login</label>
              <input
                type="text"
                class="form-control"
                maxlength="50"
                v-model="cadastro.login"
                id="_login"
                placeholder="Login"
                required
              />
            </div>
            <div class="form-group col-6">
              <label for="_email">Email</label>
              <input
                type="email"
                class="form-control"
                id="_email"
                placeholder
                required
                v-model="cadastro.email"
                maxlength="100"
              />
            </div>
              <div class="form-group col-sm-6">
                <label for="_funcionarios">Número de funcionários</label>
                <input
                  type="number"
                  class="form-control"
                  id="_funcionarios"
                  placeholder="Número de funcionários"
                  required
                  v-model="cadastro.numeroFuncionario"
                />
              </div>

              <div class="form-group col-md-12">
                <label for="_nomeEmpresa">Nome da empresa</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="cadastro.nomeEmpresa"
                  id="_nomeEmpresa"
                  placeholder="Nome da empresa"
                  required
                  maxlength="100"
                />
              </div>
              <div class="form-group col-sm-6">
                <label for="_telefone">Telefone</label>
                <input
                  type="tel"
                  class="form-control"
                  id="_telefone"
                  placeholder="Telefone"
                  required
                  v-model="cadastro.telefoneFixo"
                  maxlength="10"
                />
              </div>
              <div class="form-group col-sm-6">
                <label for="_telefone">Celular</label>
                <input
                  type="tel"
                  class="form-control"
                  id="_telefone"
                  placeholder="Telefone celular"
                  v-model="cadastro.telefoneCelular"
                  maxlength="11"
                />
              </div>
            <div class="col-md-3 form-group">
                <label>Trocar Senha:</label>
                <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
                    <label
                    class="btn btn-outline-secondary ls0 nott"
                    id="ativo"
                    :class="{'active': trocarSenha == true}"
                    >
                    <input type="radio" name="ativo" id="ativo" @change="fnAtiva(true)" autocomplete="off" class="valid" /> Sim
                    </label>
                    <label
                    class="btn btn-outline-secondary ls0 nott"
                    id="inativo"
                    :class="{'active': trocarSenha == false}"
                    >
                    <input type="radio" name="ativo" id="inativo"  @change="fnAtiva(false)"  autocomplete="off" class="valid" /> Não
                    </label>
                </div>
            </div>

            <div v-if="trocarSenha" class="col-sm-12">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="_senha">Senha</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="cadastro.senha"
                  id="_senha"
                  placeholder="Senha"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="_confirmesenha">Confirme a senha</label>
                <input
                  type="password"
                  class="form-control"
                  id="_confirmesenha"
                  placeholder="Confirme a senha"
                  v-model="confirmeSenha"
                  
                />
                </div>
            </div>

              </div>
            </div>
            <button type="submit" class="btn btn-primary ml-auto">Salvar</button>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getSuccess,clientKey,validarCNPJ } from "../global/utils";

export default {
  data() {
    return {
      cadastro: {
          senha:null
      },
      idCadastro: null,
      confirmeSenha: null,
      trocarSenha: false,
    };
  },
    mounted() {
    this.configCabecalho();
    },
 methods: {
    async fnCadastra(e) {
      e.preventDefault();
      if (this.cadastro.senha == this.confirmeSenha) {
        this.cadastro.tsInclusao = this.$moment().format();
        await this.$http
          .put("clientes/"+this.idCadastro, this.cadastro)
          .then(() => {
            getSuccess();
          })
          .catch(() => {});
      } else {
        this.$toasted.global.defaultError({ msg: "Senhas não conferem!" });
      }
    }, validaCnpj(){
      var cpfValido = validarCNPJ(this.cadastro.cnpj);
      if(!cpfValido){
         this.$toasted.global.defaultInfo({
            msg: "CNPJ inválido",
          });
          this.cadastro.cnpj = null;
      }
    },
    convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
       async configCabecalho(){
           console.log('a')
            var token = localStorage.getItem(clientKey)
            var dataToken = this.convertToken(token)
            this.idCadastro =dataToken.ClienteId
            await this.$http
            .get("clientes/"+this.idCadastro)
            .then((res) => {
                this.cadastro = res.data
                console.log(res)
            })
            .catch(() => {});

        },
    fnAtiva(val){
        if(this.trocarSenha != val){this.trocarSenha = !this.trocarSenha}
        this.cadastro.senha = null
        this.confirmeSenha = null
    }
  },
};
</script>

<style lang="scss" scoped>
</style>